export let StateOfUseBrick = /*#__PURE__*/function (StateOfUseBrick) {
  StateOfUseBrick[StateOfUseBrick["INITIAL"] = 0] = "INITIAL";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK"] = 1] = "USE_BRICK";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_ITEM"] = 2] = "USE_BRICK_ITEM";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_PROPERTIES"] = 3] = "USE_BRICK_PROPERTIES";
  // Compatible mode
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_TRANSFORM"] = 4] = "USE_BRICK_TRANSFORM";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_EVENTS"] = 5] = "USE_BRICK_EVENTS";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_IF"] = 6] = "USE_BRICK_IF";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_SLOTS"] = 7] = "USE_BRICK_SLOTS";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_SLOTS_ITEM"] = 8] = "USE_BRICK_SLOTS_ITEM";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_SLOTS_ITEM_BRICKS"] = 9] = "USE_BRICK_SLOTS_ITEM_BRICKS";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_SLOTS_ITEM_BRICKS_ITEM"] = 10] = "USE_BRICK_SLOTS_ITEM_BRICKS_ITEM";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_LIFECYCLE"] = 11] = "USE_BRICK_LIFECYCLE";
  StateOfUseBrick[StateOfUseBrick["USE_BRICK_DATA_SOURCE"] = 12] = "USE_BRICK_DATA_SOURCE";
  return StateOfUseBrick;
}({});
export function isLazyContentInUseBrick(state) {
  switch (state) {
    case StateOfUseBrick.USE_BRICK_PROPERTIES:
    case StateOfUseBrick.USE_BRICK_TRANSFORM:
    case StateOfUseBrick.USE_BRICK_EVENTS:
    case StateOfUseBrick.USE_BRICK_IF:
    case StateOfUseBrick.USE_BRICK_LIFECYCLE:
    case StateOfUseBrick.USE_BRICK_DATA_SOURCE:
      return true;
  }
  return false;
}
export function getNextStateOfUseBrick(state, isArray, key) {
  if (isLazyContentInUseBrick(state)) {
    return state;
  }
  if (isArray) {
    switch (state) {
      case StateOfUseBrick.USE_BRICK:
        return StateOfUseBrick.USE_BRICK_ITEM;
      case StateOfUseBrick.USE_BRICK_SLOTS_ITEM_BRICKS:
        return StateOfUseBrick.USE_BRICK_SLOTS_ITEM_BRICKS_ITEM;
    }
  } else {
    switch (state) {
      case StateOfUseBrick.INITIAL:
        if (key === "useBrick") {
          return StateOfUseBrick.USE_BRICK;
        }
        break;
      case StateOfUseBrick.USE_BRICK:
      case StateOfUseBrick.USE_BRICK_ITEM:
      case StateOfUseBrick.USE_BRICK_SLOTS_ITEM_BRICKS_ITEM:
        {
          switch (key) {
            case "properties":
              return StateOfUseBrick.USE_BRICK_PROPERTIES;
            case "transform":
              return StateOfUseBrick.USE_BRICK_TRANSFORM;
            case "dataSource":
              return StateOfUseBrick.USE_BRICK_DATA_SOURCE;
            case "events":
              return StateOfUseBrick.USE_BRICK_EVENTS;
            case "slots":
              return StateOfUseBrick.USE_BRICK_SLOTS;
            case "children":
              return StateOfUseBrick.USE_BRICK_SLOTS_ITEM_BRICKS;
            case "if":
              return StateOfUseBrick.USE_BRICK_IF;
            case "lifeCycle":
              return StateOfUseBrick.USE_BRICK_LIFECYCLE;
          }
          break;
        }
      case StateOfUseBrick.USE_BRICK_SLOTS:
        return StateOfUseBrick.USE_BRICK_SLOTS_ITEM;
      case StateOfUseBrick.USE_BRICK_SLOTS_ITEM:
        if (key === "bricks") {
          return StateOfUseBrick.USE_BRICK_SLOTS_ITEM_BRICKS;
        }
        break;
    }
  }
  return StateOfUseBrick.INITIAL;
}
//# sourceMappingURL=getNextStateOfUseBrick.js.map